/**
 * Sagas for Written Answer Checks (WACs)
 */

import { put, call } from 'redux-saga/effects';
import log from 'loglevel';
import moment from 'moment';

import { throttledTakeEvery } from 'phoenix2/utils';

import { REQUEST_MAINTENANCE, SET_MAINTENANCE_MODE, SERVER_ERROR } from './actions';

import { setRootView } from 'phoenix2/state/views/actions';
import { showAlert } from 'phoenix2/state/alert/sagas';

/**
 * Saga to watch for REQUEST_MAINTENANCE actions
 */
export function* watchRequestMaintenance() {
    yield throttledTakeEvery(REQUEST_MAINTENANCE, doRequestMaintenance, 0);
}

/**
 * Saga to put the app into maintenance mode, showing the maintenance view
 */
export function* doRequestMaintenance() {
    log.debug('requested maintenance');
    yield put(setRootView({ type: 'maintenance' }));
}

/**
 * Saga to watch for SET_MAINTENANCE_MODE actions
 */
export function* watchSetMaintenanceMode() {
    yield throttledTakeEvery(SET_MAINTENANCE_MODE, doSetMaintenanceMode, 0);
}

/**
 * Saga to set maintenance mode - showing a warning to the user that the app
 * will go into maintenance mode after a certain time period
 * @param action The action, which includes the timeout in seconds
 */
export function* doSetMaintenanceMode(action) {
    const { mode, timeout } = action;

    log.debug('Notified maintenance mode (' + mode + ') in ' + timeout + ' seconds');

    // If maintenance has been disabled, don't show an alert.
    if (mode) {
        const timeoutText = moment.duration(timeout, 'seconds').humanize();

        try {
            // Inform the user about the maintenance with an alert:
            yield call(showAlert, {
                title: 'We need to update Sparx Web',
                message:
                    'You will be logged out in ' +
                    timeoutText +
                    ' so we' +
                    ' can update Sparx Web.',
            });
        } catch (exc) {
            // If alert aborted, just carry on
        }
    }
}

export function* watchServerError() {
    yield throttledTakeEvery(SERVER_ERROR, doServerError, 0);
}

export function* doServerError() {
    log.debug('server error');
    yield put(setRootView({ type: 'server-error', viewId: 'server-error' }));
}
